import React from 'react';
import classes from './ExperiencesShapes.module.css';
import { Donut } from 'react-awesome-shapes/dist/shapes/donut';
import { Cross } from 'react-awesome-shapes/dist/shapes/cross';
import { Circle } from 'react-awesome-shapes/dist/shapes/circle';
import { Diamond } from 'react-awesome-shapes/dist/shapes/diamond';
// import { Polygon } from "react-awesome-shapes/dist/shapes/polygon";
// import { Star } from "react-awesome-shapes/dist/shapes/star";
import { CircleGrid } from 'react-awesome-shapes/dist/shapes/circlegrid';
import { SquareDonut } from 'react-awesome-shapes/dist/shapes/squareDonut';

const ExperiencesShapes = () => {
  return (
    <>
      <div style={{ position: 'relative' }}>
        <Circle
          className={classes.circle}
          top=" 120px"
          left=" -20px"
          color="#f3904f99"
          size={['70px', '110px', '110px', '110px']}
          zIndex={0}
        />
        <Circle
          className={classes.circle2}
          color="#4dbef399"
          size={['30px', '30px', '30px', '30px']}
          zIndex={0}
        />
        <CircleGrid
          className={classes.circleGrid}
          color="#b1eb4499"
          size="110px"
          zIndex={0}
        />
        {/* <Polygon
          className={classes.square}
          height="80px"
          width="80px"
          zIndex={0}
          color="#423f3daa99"
          sides={4}
        /> */}
        <Diamond
          className={classes.diamond}
          color="#cc2c5799"
          size="50px"
          zIndex={0}
        />
        <Donut
          className={classes.donut}
          color="#0edc5999"
          size="40px"
          width={['10px', '10px', '60px', '60px']}
          zIndex={0}
        />
        <Donut
          className={classes.donut2}
          color="#88373799"
          size="100px"
          width={['20px', '20px', '60px', '60px']}
          zIndex={0}
        />
        <Diamond
          className={classes.diamond2}
          color="#4a07e599"
          size="60px"
          zIndex={-1}
        />
        <CircleGrid
          className={classes.circleGrid2}
          color="#006b8e99"
          size="170px"
          zIndex={0}
        />
        <SquareDonut
          className={classes.squaredonut}
          size="50px"
          zIndex={0}
          color="#b3ff0099"
        />
        {/* <Polygon
          className={classes.square2}
          height="40px"
          width="40px"
          zIndex={0}
          color="#423f3daa99"
          sides={4}
        /> */}
        <Cross
          className={classes.cross}
          size="150px"
          zIndex={0}
          color="#6a2e0699"
        />
        <Circle
          className={classes.circle3}
          color="#270a7799"
          size={['30px', '30px', '150px', '150px']}
          zIndex={0}
        />
        <Diamond
          className={classes.diamond3}
          color="#423f3daa99"
          size="80px"
          zIndex={0}
        />
        <Donut
          className={classes.donut3}
          color="#afaba899"
          size="120px"
          width={['30px', '30px', '60px', '60px']}
          zIndex={0}
        />
        {/* <Polygon
          className={classes.triangle}
          height="80px"
          width="100px"
          zIndex={0}
          color="#423f3daa99"
          sides={3}
        /> */}
      </div>
    </>
  );
};

export default ExperiencesShapes;
